import * as React from 'react'
import { SVG_WhiteCross } from '../svg/SVG_WhiteCross'

interface Props {
    leftNode?: React.ReactNode
    label: string
    onRemove: () => void
}

export class SelectedOption extends React.Component<Props, {}> {
    public render() {
        return (
            <div className="AppCore__ui__SelectedOption">
                {this.props.leftNode && (
                    <div className="AppCore__ui__SelectedOption__leftNode">{this.props.leftNode}</div>
                )}
                <zaptic-ellipsis class="AppCore__ui__SelectedOption__label">{this.props.label}</zaptic-ellipsis>
                <div className="AppCore__ui__SelectedOption__clear" onClick={this.props.onRemove}>
                    <SVG_WhiteCross />
                </div>
            </div>
        )
    }
}
